import { Flex } from '@mantine/core';

import { EvaluationFacultySummaryXlsxButton } from '@/module/Evaluation/components/EvaluationFacultySummaryXlsxButton';

import { Id } from '@feature/utils';

interface EvaluationFacultySummaryProps {
  facultyId: number;
  evaluationId: Id;
}

export function EvaluationFacultySummary({ facultyId, evaluationId }: EvaluationFacultySummaryProps) {
  return (
    <Flex gap="10px">
      <EvaluationFacultySummaryXlsxButton
        facultyId={facultyId}
        evaluationId={evaluationId}
      />
    </Flex>
  );
}
